import React, { useRef, useState } from "react";
import SaveSuccessModal from "./SaveSuccessModal";

const BusinessSetting = () => {
  const [inputFile, setInputFile] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const logoRef = useRef();
  const saveSuccessModalRef = useRef();
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("logo", logoRef.current.files[0]);
    formData.append("name", e.target.name.value);
    formData.append("address", e.target.address.value);
    formData.append("city", e.target.city.value);
    formData.append("state", e.target.state.value);
    formData.append("zip", e.target.zip.value);
    formData.append("country", e.target.country.value);
    formData.append("date", new Date());
    setIsLoading(true);
    fetch("https://supplement-selling-secret.herokuapp.com/business", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.insertedId) {
          setIsLoading(false);
          e.target.reset();
          setInputFile("");
          saveSuccessModalRef.current.click();
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  return (
    <div className="text-accent">
      <SaveSuccessModal saveSuccessModalRef={saveSuccessModalRef} />
      <h1 className="lg:ml-20 ml-10 mt-5 mb-10 lg:text-2xl text-xl font-bold text-accent uppercase">
        BUSINESS SETTINGS
      </h1>
      <div className="bg-blue-50 md:p-5 p-0">
        <div className="md:p-10 p-5 bg-white">
          <h1 className="font-bold mb-5">My Business setting</h1>

          <p className="mb-3 mt-5 font-bold text-sm">
            NOTE: Please upload vector file logo (PDF, EPS or Ai) that is no
            larger than 000MB
          </p>
          <div className="flex gap-5 items-start my-5">
            <label htmlFor="" className="text-sm">
              Upload your own logo{" "}
            </label>
            <div>
              <input
                value={inputFile}
                ref={logoRef}
                onChange={(e) => setInputFile(e.target.value)}
                className="mx-2 border-0 file:bg-white file:outline-0 file:text-accent file:px-5 file:py-1 file:rounded-xl file:border file:border-accent text-gray-400"
                type="file"
                name="logo"
                id="inputFile"
              />

              {inputFile && (
                <p className="md:ml-20 mt-3">
                  {inputFile &&
                    inputFile.split("\\")[inputFile.split("\\").length - 1]}

                  <label htmlFor="inputFile" className="mx-5">
                    change
                  </label>
                  <span
                    onClick={() => setInputFile("")}
                    className="cursor-pointer"
                  >
                    X
                  </span>
                </p>
              )}
            </div>
          </div>

          <p className="font-bold my-3 italic md:text-base text-sm">
            No Logo? Do not worry, when you go to the design studio you can
            request logo design there!
          </p>
          <form
            onSubmit={handleFormSubmit}
            className="md:w-4/5 w-full mt-10"
            action=""
          >
            <div className="w-full grid grid-cols-3 gap-3">
              {[
                {
                  id: 1,
                  label: "Name:",
                  type: "text",
                  name: "name",
                },
                {
                  id: 2,
                  label: "Street Address",
                  type: "text",
                  name: "address",
                },
                {
                  id: 3,
                  label: "City:",
                  type: "text",
                  name: "city",
                },
                {
                  id: 4,
                  label: "State:",
                  type: "text",
                  name: "state",
                },
                {
                  id: 5,
                  label: "Zip/Postal Code:",
                  type: "text",
                  name: "zip",
                },
                {
                  id: 6,
                  label: "Country:",
                  type: "text",
                  name: "country",
                },
              ].map((data, i) => (
                <React.Fragment key={data.id + i}>
                  <label className="text-accent font-bold" htmlFor="">
                    {data.label}
                  </label>
                  <input
                    className="text-gray-500 p-2 w-full col-span-2 border border-accent"
                    type={data.type}
                    placeholder=""
                    name={data.name}
                    required
                    id=""
                  />
                </React.Fragment>
              ))}
            </div>
            {!isLoading && (
              <input
                htmlFor="saveSuccessModal"
                className="inline-block bg-slate-500 text-white rounded-xl px-9 py-3 mt-10 cursor-pointer"
                type="submit"
                value={"Save"}
              />
            )}
            {isLoading && spinner}
          </form>
        </div>
      </div>
    </div>
  );
};

export default BusinessSetting;

const spinner = (
  <div role="status">
    <svg
      class="inline mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
    <span class="sr-only">Loading...</span>
  </div>
);
